export const Tagline = ({ className = "", size = "text-lg sm:text-xl", testId = "tagline" }) => (
  <p
    className={`${size} text-white leading-none ${className}`}
    style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.02em" }}
    data-testid={testId}
  >
    our <span className="text-[#FACC15] font-bold">idea</span>, your business
  </p>
);

export default Tagline;
